import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-teal via-teal/90 to-teal/80 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <span className="font-bold text-2xl">PointCalls</span>
            </div>
            <p className="text-white/90 text-sm mb-4">
              Making a point for your calls.
            </p>
            <p className="text-white/80 text-sm mb-6">
              AI phone agents for high-call-volume service businesses. Answer, qualify, and book - 24/7.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <a href="mailto:support@pointcalls.com" className="hover:text-white/80 transition-colors cursor-pointer">
                support@pointcalls.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Solutions</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/industries#law" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Law Firms
                </Link>
              </li>
              <li>
                <Link to="/industries#real-estate" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Real Estate
                </Link>
              </li>
              <li>
                <Link to="/industries#roofing" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Roofing Companies
                </Link>
              </li>
              <li>
                <Link to="/industries#recruiting" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Recruiting & HR
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/features" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/partnerships" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Partnerships
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+16787376473" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  +1 (678) 737-6473
                </a>
              </li>
              <li>
                <a href="mailto:support@pointcalls.com" className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  support@pointcalls.com
                </a>
              </li>
              <li>
                <a 
                  href="https://tidycal.com/mattv/15-minute-meeting" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/90 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  Book a Demo
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/80 text-sm">
            © 2025 PointCalls. All rights reserved.
          </p>
          <p className="text-white/80 text-sm">
            Built for high-call-volume service businesses
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
